module.exports = __webpack_public_path__ + "static/media/work1.4.cfe5da2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/work1.4.png
// module id = 519
// module chunks = 4